(ns hai.knowledge.assistants.helper
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]))

(def ->label :ai-model-config/title)

(def icon icons/outlined-web)

(defn ->icon
  [_mini-app]
  icon)

(defn ->tint
  [_]
  t/--colour-blue)

